/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Copy_Link_ButtonInputs */



/**
* | output |
* | --- |
* | "Copy Link" |
*
* @param {Team_Share_Copy_Link_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_copy_link_button = /** @type {((inputs?: Team_Share_Copy_Link_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Copy_Link_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier le lien")
	if (locale === "de") return /** @type {LocalizedString} */ ("Link kopieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia collegamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скопировать ссылку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar enlace")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("复制链接")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リンクをコピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लिंक की प्रतिलिपि करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar link")
	return /** @type {LocalizedString} */ ("Copy Link")
});